<template>
  <div  id="register-background">
    <IndexNav></IndexNav>
<v-container class="form-background mt-16" fluid style="max-width: 95% !important;">
  <div class="d-inline-flex align-baseline pb-12 justify-space-between" style="width: 100%">
    <div class="d-flex align-baseline">
      <h1 class="text-left text-uppercase pr-16" style="color: var(--v-darkGreen-base); font-family: 'Poppins', sans-serif">Registrujte se</h1><span>Máte již účet? <router-link :to="{name: 'login'}">Přihlaste se</router-link></span>
    </div>
    <v-alert
      class="float-right"
      v-if="!formValid || submitWait"
      border="top"
      color="red lighten-3"
      dark
    >
      Vyplňte prosím všechna pole s hvězdičkou
    </v-alert>
  </div>
      <v-form
        ref="form"
        v-model="formValid"
      >
          <v-row>
            <v-alert type="error" v-if="emailError">
              E-mail je již používán.
            </v-alert>
            <v-alert  type="error" v-if="unspecifiedError">
              Chyba.
            </v-alert>
            <v-alert type="success" v-if="successAlert">
              Registrace proběhla úspěšně.
            </v-alert>
            <v-col cols="12" md="8">
              <v-row>
                <v-col>
                  <label>Vaše jméno*</label>
                  <v-text-field
                    class="rounded-lg"
                    outlined
                    color="green"
                    v-model="form.firstName"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <label>Vaše příjmení*</label>
                  <v-text-field
                    class="rounded-lg"
                    outlined
                    color="green"
                    v-model="form.lastName"
                    :rules="[rules.required]"
                    label="Příjmení"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <label>Váš e-mail*</label>
                  <v-text-field
                    class="rounded-lg"
                    outlined
                    color="green"
                    v-model="form.email"
                    :rules="[rules.required, rules.email]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <label>Váš telefon*</label>
                  <v-text-field
                    class="rounded-lg"
                    outlined
                    color="green"
                    v-model="form.phone1"
                    :rules="[rules.required, rules.phone]"
                    label="Telefon"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <label>Váš telefon č.2</label>
                  <v-text-field
                    class="rounded-lg"
                    outlined
                    color="green"
                    v-model="form.phone2"
                    :rules="[rules.phone]"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <label>Váš telefon č.3</label>
                  <v-text-field
                    class="rounded-lg"
                    outlined
                    color="green"
                    v-model="form.phone3"
                    :rules="[rules.phone]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <label>Vaše heslo*</label>
                  <v-text-field
                    class="rounded-lg"
                    outlined
                    color="green"
                    v-model="form.password"
                    :rules="[rules.required, rules.minLength(6)]"
                    :type="show1 ? 'text' : 'password'"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show1 = !show1"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <label>Opakujte heslo*</label>
                  <v-text-field
                    class="rounded-lg"
                    outlined
                    color="green"
                    v-model="form.passwordConfirmation"
                    :rules="[rules.required, formRules.passwordConfirmation]"
                    :type="show2 ? 'text' : 'password'"
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show2 = !show2"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="8">
                  <label>Ulice*</label>
                  <v-text-field
                    class="rounded-lg"
                    outlined
                    color="green"
                    v-model="form.street"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <label>Číslo popisné*</label>
                  <v-text-field
                    class="rounded-lg"
                    outlined
                    color="green"
                    v-model="form.streetNumber"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="8">
                  <label>Město*</label>
                  <v-text-field
                    class="rounded-lg"
                    outlined
                    color="green"
                    v-model="form.city"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <label>PSČ*</label>
                  <v-text-field
                    class="rounded-lg"
                    outlined
                    color="green"
                    v-model="form.zip"
                    :rules="[rules.required]"
                    label="PSČ"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="4">
              <v-row>
                <v-col>
                  <label>Městská část*</label>
                  <v-select
                    class="rounded-lg"
                    color="green"
                    v-model="form.cityDistrictId"
                    :items="districts"
                    item-text="name"
                    item-value="id"
                    :rules="[rules.required]"
                    outlined
                  ></v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <label>Popis</label>
                  <v-textarea
                    color="green"
                    class="rounded-lg"
                    v-model="form.description"
                    rows="3"
                    outlined
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <label>Typ stravy</label>
                  <v-select
                    class="rounded-lg"
                    outlined
                    color="green"
                    v-model="form.foodTypes"
                    :items="foodTypes"
                    item-text="name"
                    item-value="id"
                    :search-input.sync="search"
                    hide-selected
                    multiple
                    persistent-hint
                    small-chips
                    return-object
                    deletable-chips
                  ></v-select>
                </v-col>
              </v-row>

              <v-checkbox
                color="green"
                v-model="form.delivery"
                label="Jiná dodací adresa"
              ></v-checkbox>

              <div v-if="form.delivery">
                <v-row>
                  <v-col cols="8">
                    <v-text-field
                      class="rounded-lg"
                      outlined
                      color="green"
                      v-model="form.deliveryStreet"
                      :rules="form.delivery? [rules.required] : []"
                      label="Ulice"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="4">
                    <v-text-field
                      class="rounded-lg"
                      outlined
                      color="green"
                      v-model="form.deliveryStreetNumber"
                      :rules="form.delivery? [rules.required] : []"
                      label="Č. p."
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="8">
                    <v-text-field
                      class="rounded-lg"
                      outlined
                      color="green"
                      v-model="form.deliveryCity"
                      :rules="form.delivery? [rules.required] : []"
                      label="Město"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="4">
                    <v-text-field
                      class="rounded-lg"
                      outlined
                      color="green"
                      v-model="form.deliveryZip"
                      :rules="form.delivery? [rules.required] : []"
                      label="PSČ"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-select
                      class="rounded-lg"
                      color="green"
                      v-model="form.deliveryCityDistrictId"
                      label="Městská část"
                      :items="districts"
                      :rules="form.delivery? [rules.required] : []"
                      item-text="name"
                      outlined
                      item-value="id"
                    ></v-select>
                  </v-col>
                </v-row>
              </div>

              <v-checkbox
                color="green"
                v-model="form.company"
                label="Jsem firma"
              ></v-checkbox>

              <div v-if="form.company">
                <v-row>
                  <v-col>
                    <v-text-field
                      class="rounded-lg"
                      outlined
                      color="green"
                      v-model="form.companyName"
                      :rules="form.company? [rules.required] : []"
                      label="Název"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      class="rounded-lg"
                      outlined
                      color="green"
                      v-model="form.ico"
                      :rules="form.company? [rules.required] : []"
                      label="IČO"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col>
                    <v-text-field
                      class="rounded-lg"
                      outlined
                      color="green"
                      v-model="form.dic"
                      label="DIČ"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>
              <v-row>
                <v-col>
                  <v-select
                    class="rounded-lg"
                    outlined
                    color="green"
                    :items="packagingTypes"
                    label="Způsob balení"
                    v-model="form.preferredCustomPackaging"
                  >
                  </v-select>
                </v-col>
                <v-col></v-col>
              </v-row>

              <v-checkbox
                color="green"
                v-model="tos"
                required
                :rules="[rules.tos]"
              >
                <div slot="label"
                     color="green">
                  Souhlasím s
                  <a href="./vop.pdf" @click.stop target="_blank">
                    obchodními podmínkami a GDPR*
                  </a>
                </div>
              </v-checkbox>
              <v-btn
                :disabled="!formValid || submitWait"
                color="lightGreen"
                style="width: 100%; color: white"
                class="py-6"
                @click="register"
              >
                Zaregistrovat se
              </v-btn>
            </v-col>
          </v-row>
      </v-form>
</v-container>
  </div>
</template>

<script>
import rules from '../../../mixins/rules'
import IndexNav from '@/views/IndexNav'
export default {
  components: { IndexNav },
  mixins: [rules],
  name: 'RegisterForm',
  data () {
    return {
      emailError: false,
      successAlert: false,
      unspecifiedError: false,
      submitWait: false,
      packagingTypes: [
        {
          text: 'Standardní balení',
          value: false
        },
        {
          text: 'Vlastní nádoba',
          value: true
        }
      ],
      show1: false,
      show2: false,
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone1: '',
        phone2: '',
        phone3: '',
        password: '',
        passwordConfirmation: '',
        street: '',
        streetNumber: '',
        city: '',
        zip: '',
        cityDistrictId: null,
        description: null,
        foodTypes: [],
        delivery: false,
        deliveryStreet: null,
        deliveryStreetNumber: null,
        deliveryCity: null,
        deliveryZip: null,
        deliveryCityDistrictId: null,
        company: false,
        companyName: null,
        ico: null,
        dic: null,
        roleId: 6,
        preferredCustomPackaging: false
      },

      tos: false,
      formRules: {
        passwordConfirmation: v => v === this.form.password || 'Zadejte prosím stejné heslo.'
      },
      formValid: true,
      foodTypes: [],
      model: ['Vuetify'],
      search: null,
      districts: []
    }
  },
  methods: {
    register () {
      this.submitWait = true
      this.emailError = false
      this.$http.post('/register', this.keysToSnakeCase(this.form))
        .then(response => {
          window.scrollTo(0, 0)
          this.submitWait = false
          this.successAlert = true
          this.$refs.form.reset()
          setTimeout(() => {
            this.$router.push({ name: 'login' })
          }, 2000)
        })
        .catch(err => {
          this.submitWait = false
          window.scrollTo(0, 0)
          if (err.response.status === 403) {
            this.emailError = true
          } else {
            this.unspecifiedError = true
            setTimeout(() => { this.unspecifiedError = false }, 3000)
          }
        })
    },
    initialize () {
      this.$http.get('/city-districts')
        .then(response => {
          this.districts = this.keysToCamelCase(response.data)
            .sort(function (a, b) {
              const nameA = a.name.toUpperCase() // ignore upper and lowercase
              const nameB = b.name.toUpperCase() // ignore upper and lowercase
              if (nameA < nameB) {
                return -1
              }
              if (nameA > nameB) {
                return 1
              }
              return 0 // names are equal
            })
        })
        .catch(err => console.log(err))
      this.$http.get('/food-types')
        .then(response => {
          this.foodTypes = this.keysToCamelCase(response.data)
        })
        .catch(err => console.log(err))
    }
  },
  watch: {
    'form.delivery': function () {
      if (!this.form.delivery) {
        this.form.deliveryCity = null
        this.form.deliveryStreetNumber = null
        this.form.deliveryStreet = null
        this.form.deliveryZip = null
        this.form.deliveryDistrictId = null
      }
    },
    'form.company': function () {
      if (!this.form.company) {
        this.form.companyName = null
        this.form.ico = null
        this.form.dic = null
      }
    }
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped>
.col{
  padding-bottom: 0;
  padding-top: 0;
}
  #register-background{
    height:100%;
    background-color: var(--v-lightGray-base);
    font-family: "Readex Pro", sans-serif;
  }
  .form-background{
    border-radius: 25px;
    max-width: 1200px;
    margin: auto;
  }
  >>>.v-input__slot{
    background-color: white !important;
  }
  >>>.theme--light.v-input input, >>>.theme--light.v-input textarea{
    color: var(--v-darkGreen-base) !important;
  }
  a{
    color: var(--v-lightGreen-base) !important;
    text-decoration: none;
  }
</style>
